import * as React from "react";
import { Icon } from '@fluentui/react';
import { ExclamationTriangleIcon, BulletsIcon, CallIcon, MentionIcon, MoreIcon, ShieldKeyholeIcon } from '@fluentui/react-icons-northstar';
import { Avatar, Button, Flex, FlexItem, Image, Grid, MenuButton, Pill, Popup, Text, Tooltip, VideoCameraEmphasisIcon, PaperclipIcon } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import { DateTimeParser } from "../../../helpers/date-time";
import { LoaderInfinite } from "../../loaders/loaders";
import StatusQueueConstants from "../../../constants/status-queue";
import Roles from "../../../constants/roles";

const moment = require('moment');

interface IListagemEncerradoProps extends WithTranslation {
    item: any,
    status: string,
    getLabelStatusLocale: Function,
    onViewHistory: Function,
    authEnabled: boolean,
    govBrEnabled: boolean,
    filtered: boolean,
    internalAccessEnabled: boolean,
    role: string,
    isAdmin: boolean,
    pageSize: number,
    loadingInfinite: boolean,
    isTeamContext?: boolean,
}

const ListagemEncerrado: React.FunctionComponent<IListagemEncerradoProps> = props => {
    const localize = props.t;

    const parseTime = (start: any, end: any) => {
        var startTime = moment(start);
        var endTime = moment(end);

        var duration = moment.duration(endTime.diff(startTime));

        return [
            duration._data.hours.toString().padStart(2, '0'),
            duration._data.minutes.toString().padStart(2, '0'),
            duration._data.seconds.toString().padStart(2, '0')
        ].join(":");
    }

    return (
        <Flex fill column>
            {!props.item.length ?
                <Flex hAlign="center" gap="gap.medium" styles={{ marginTop: '60px' }}>
                    <ExclamationTriangleIcon outline />
                    <Text size="small" weight="light" content={`${localize("NaoExistem")} atendimentos encerrados ${localize("NestaUnidade")}`} />
                </Flex>
                :
                <Grid
                    columns={((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) ?
                        'minmax(200px, 300px) minmax(70px, 70px) minmax(120px, 200px) minmax(120px, 200px) 0.2fr 0.3fr 0.3fr 0.3fr 0.3fr' :
                        'minmax(200px, 300px) minmax(70px, 70px) minmax(120px, 200px) 0.2fr 0.3fr 0.3fr 0.3fr 0.3fr'
                    }>
                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text content={localize("StatusAtendimento")} className="margin-style header-nome-serventia" />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip
                                trigger={<Icon className="margin-style info-icon" iconName="Info" />}
                                content={
                                    <React.Fragment>
                                        <Text content={`\u25CF ${localize("UsuarioNaFila")}`} />
                                        <br /><br />
                                        <Text content={`\u25CF ${localize("AtendimentoConfirmado")}`} />
                                        <br /><br />
                                        <Text content={`\u25CF ${localize("UsuarioEntrou")}`} />
                                    </React.Fragment>
                                }
                            />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header">

                    </Flex>

                    {((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) &&
                        <Flex gap="gap.small" className="header">
                            <FlexItem>
                                <Text className="margin-style" content={`Solicitante`} />
                            </FlexItem>
                        </Flex>
                    }

                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text className="margin-style" content={localize("Atendente")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("AtendenteResponsavel")} />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("Horario")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("HorarioSolicitacao")} />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("TempoEspera")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("TempoEsperaAtendimento")} />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("HorarioAtendimento")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("HorarioAtendimento")} />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("TempoAtendimento")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("TempoAtendimento")} />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("HorarioEncerramento")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("HorarioEncerramento")} />
                        </FlexItem>
                    </Flex>

                    {props.item.map((item: any, index: number) => {
                        let queue = item?.queue;
                        let history = queue?.History ?? null;
                        let tempoEspera = "";
                        let tempoAtendimento = "-";
                        let horarioAtendimento = "-";
                        let horarioEncerramento = "";

                        if (history) {
                            let itemNaFila = history.find((e: any) => e.status == StatusQueueConstants.naFila);
                            let itemIniciado = history.find((e: any) => e.status == StatusQueueConstants.atendimentoIniciado);
                            let itemEmAtendimento = history.find((e: any) => e.status == StatusQueueConstants.emAtendimento);
                            let itemEncerrado = history.find((e: any) => e.status == StatusQueueConstants.atendimentoEncerrado);
                            let itemEncerradoInatividade = history.find((e: any) => e.status == StatusQueueConstants.atendimentoInativo);
                            let itemCancelado = history.find((e: any) => e.status == StatusQueueConstants.atendimentoCancelado);
                            let itemAgendado = history.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado);

                            if (itemEmAtendimento) {
                                tempoEspera = parseTime(itemNaFila?.created, itemEmAtendimento?.created);
                                tempoAtendimento = parseTime(itemEmAtendimento?.updated, itemEncerrado?.updated);
                                horarioAtendimento = DateTimeParser.dateOffsetParser(itemEmAtendimento?.updated).format("HH:mm");
                            }

                            if (itemCancelado) {
                                tempoEspera = parseTime(itemNaFila?.created, itemCancelado?.created);
                                horarioEncerramento = DateTimeParser.dateOffsetParser(itemCancelado?.updated).format("HH:mm");
                            }
                            else if (itemEncerrado) {
                                horarioEncerramento = DateTimeParser.dateOffsetParser(itemEncerrado?.updated).format("HH:mm");

                                if (!itemEmAtendimento)
                                    tempoEspera = "-"
                            }
                            else if (itemEncerradoInatividade) {
                                tempoEspera = parseTime(itemNaFila?.created, itemEncerradoInatividade?.created);
                                horarioEncerramento = DateTimeParser.dateOffsetParser(itemEncerradoInatividade?.updated).format("HH:mm");
                            }

                            if (itemAgendado) {
                                tempoEspera = parseTime(itemIniciado?.created, itemEmAtendimento?.created);

                                if (itemEncerrado) {
                                    if (!itemEmAtendimento)
                                        tempoEspera = "-"
                                }

                                if (itemEncerradoInatividade) {
                                    tempoEspera = parseTime(itemIniciado?.created, itemEncerradoInatividade?.created);
                                }

                                if (itemCancelado) {
                                    tempoEspera = parseTime(itemAgendado?.created, itemCancelado?.created);

                                    if (!itemIniciado)
                                        tempoEspera = "-"
                                }
                            }
                        }

                        let queueId = `#${queue?.id.substr(queue?.id.length - 6)} ${props.getLabelStatusLocale(queue?.status)}`;
                        let prefix = "#";

                        if (props.isTeamContext) {
                            prefix = !queue.AdditionalData?.prefix ? prefix : queue.AdditionalData.prefix;
                        }

                        if (queue.AdditionalData?.nrProcesso) {
                            queueId = `${queue.AdditionalData?.nrProcesso} ${props.getLabelStatusLocale(queue?.status)}`;
                        }

                        return (
                            <React.Fragment key={index}>
                                <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    {!props.isTeamContext ?
                                        <FlexItem>
                                            <Flex vAlign="center" gap="gap.medium">
                                                <Text
                                                    onClick={() => props.onViewHistory(queue?.id, queue?.Ancora)}
                                                    styles={{ cursor: "pointer", marginLeft: '3.5rem' }}
                                                    className="text-ms-color"
                                                    content={queueId}
                                                />
                                            </Flex>
                                        </FlexItem>
                                        :
                                        <Tooltip
                                            trigger={
                                                <Flex gap="gap.small" vAlign="center">
                                                    <Text
                                                        onClick={() => props.onViewHistory(queue?.id, queue?.Ancora)}
                                                        styles={{ cursor: "pointer", marginLeft: '3.5rem' }}
                                                        className="text-ms-color"
                                                        content={`${prefix}${queue?.id.substr(queue?.id.length - 6)} ${props.getLabelStatusLocale(queue?.status)}`}
                                                    />
                                                    {DateTimeParser.dateOffsetParser(queue.created).format("DD/MM/YYYY") != DateTimeParser.dateOffsetParser(new Date).format("DD/MM/YYYY") &&
                                                        <Pill
                                                            size="small"
                                                            appearance="outline"
                                                            className="date-pill"
                                                            content={DateTimeParser.dateOffsetParser(queue.created).format("DD/MM/YYYY")}
                                                        />
                                                    }
                                                </Flex>
                                            }
                                            content={`Unidade: ${queue?.nome}`}
                                            position="after"
                                            align="center"
                                        />
                                    }
                                    {props.filtered &&
                                        <Pill
                                            appearance="outline"
                                            content={DateTimeParser.dateOffsetParser(queue?.updated).format("DD/MM/YYYY")}
                                        />
                                    }
                                </Flex>

                                {!props.isAdmin && props.role == Roles.leitor ?
                                    <Flex className={queue?.isSelected ? "row row-active" : "row"} />
                                    :
                                    <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                        <FlexItem>
                                            <MenuButton
                                                tabIndex={-1}
                                                trigger={<Button icon={<MoreIcon />} iconOnly text />}
                                                on="click"
                                                menu={[
                                                    {
                                                        key: 'details',
                                                        content: localize("Detalhes"),
                                                        icon: <BulletsIcon outline />,
                                                        onClick: () => props.onViewHistory(queue?.id, queue?.Ancora),
                                                    },
                                                ]}
                                            />
                                        </FlexItem>
                                    </Flex>
                                }

                                {((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) &&
                                    <Flex gap="gap.medium" vAlign="center" className="row">
                                        {queue?.UserProfile != null &&
                                            <Popup
                                                mouseLeaveDelay={0}
                                                trigger={
                                                    <Flex gap="gap.small" vAlign="center">
                                                        {(queue?.UserProfile?.userPhoto != null && queue?.UserProfile?.userPhoto != "") ?
                                                            <Avatar
                                                                image={`data:image/jpeg;base64,${queue?.UserProfile?.userPhoto}`}
                                                                size="small"
                                                            />
                                                            :
                                                            <Flex gap="gap.smaller">
                                                                <Avatar size="small" name={queue?.UserProfile?.userName == "" ? queue?.UserProfile?.userLogin?.toUpperCase() : queue?.UserProfile?.userName} />
                                                            </Flex>
                                                        }
                                                        <Text
                                                            truncated
                                                            content={queue?.UserProfile?.userName == "" ? queue?.UserProfile?.userLogin?.split("@")[0] : queue?.UserProfile?.userName?.split(" ")[0]}
                                                        />
                                                    </Flex>
                                                }
                                                on="hover"
                                                content={
                                                    <Flex gap="gap.medium" vAlign="center" column>
                                                        <Flex gap="gap.medium" vAlign="center">
                                                            {(queue?.UserProfile?.userPhoto != null && queue?.UserProfile?.userPhoto != "") ?
                                                                <Flex hAlign="center" gap="gap.small" column>
                                                                    <Avatar
                                                                        image={`data:image/jpeg;base64,${queue?.UserProfile?.userPhoto}`}
                                                                        size="larger"
                                                                    />
                                                                    <Image width="45" src="https://studio365cdn.azureedge.net/balcaovirtual/gov-br.svg" />
                                                                </Flex>
                                                                :
                                                                <Flex gap="gap.smaller">
                                                                    <Avatar size="small" name={queue?.UserProfile?.userName == "" ? queue?.UserProfile?.userLogin?.toUpperCase() : queue?.UserProfile?.userName} />
                                                                </Flex>
                                                            }

                                                            <Flex hAlign="start" gap="gap.smaller" column>
                                                                <Text weight="semibold" content={queue?.UserProfile?.userName} />

                                                                {queue?.UserProfile?.userLogin &&
                                                                    <Flex vAlign="center" gap="gap.smaller">
                                                                        <ShieldKeyholeIcon size="smaller" outline />
                                                                        <Text weight="light" size="smaller" content={queue?.UserProfile?.userLogin} />
                                                                    </Flex>
                                                                }

                                                                {queue?.UserProfile?.email &&
                                                                    <Flex vAlign="center" gap="gap.smaller">
                                                                        <MentionIcon size="smaller" outline />
                                                                        <Text weight="light" size="smaller" content={queue?.UserProfile?.email} />
                                                                    </Flex>
                                                                }

                                                                {queue?.UserProfile?.phoneNumber &&
                                                                    <Flex vAlign="center" gap="gap.smaller">
                                                                        <CallIcon size="smaller" outline />
                                                                        <Text weight="light" size="smaller" content={queue?.UserProfile?.phoneNumber} />
                                                                    </Flex>
                                                                }
                                                            </Flex>
                                                        </Flex>
                                                    </Flex>
                                                }
                                            />
                                        }
                                    </Flex>
                                }

                                <Popup
                                    mouseLeaveDelay={0}
                                    trigger={
                                        <Flex gap="gap.smaller" vAlign="center" hAlign="start" className={queue?.isSelected ? "row row-active" : "row"}>
                                            {queue?.atendenteName &&
                                                <React.Fragment>
                                                    {(item?.atendentePhoto != null && item?.atendentePhoto != "") ?
                                                        <Avatar
                                                            image={`data:image/jpeg;base64,${item?.atendentePhoto}`}
                                                            size="small"
                                                        />
                                                        :
                                                        <Flex gap="gap.smaller">
                                                            <Avatar size="small" name={queue?.atendenteName} />
                                                        </Flex>
                                                    }

                                                    <Flex vAlign="center" gap="gap.large">
                                                        <Text content={queue?.atendenteName?.split(" ")[0]} />
                                                    </Flex>
                                                </React.Fragment>
                                            }
                                        </Flex>
                                    }
                                    on="hover"
                                    content={
                                        <Flex gap="gap.medium" vAlign="center" column>
                                            <Flex gap="gap.medium" vAlign="center">
                                                {queue?.atendenteName &&
                                                    <React.Fragment>
                                                        {(item?.atendentePhoto != null && item?.atendentePhoto != "") ?
                                                            <Avatar
                                                                image={`data:image/jpeg;base64,${item?.atendentePhoto}`}
                                                                size="small"
                                                            />
                                                            :
                                                            <Flex gap="gap.smaller">
                                                                <Avatar size="small" name={queue?.atendenteName} />
                                                            </Flex>
                                                        }

                                                        <Flex vAlign="center" gap="gap.large">
                                                            <Text content={queue?.atendenteName} />
                                                        </Flex>
                                                    </React.Fragment>
                                                }
                                            </Flex>
                                        </Flex>
                                    }
                                />

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text
                                            content={
                                                queue?.Schedule ?
                                                DateTimeParser.dateOffsetParser(queue?.Schedule.date).format("HH:mm") :
                                                DateTimeParser.dateOffsetParser(queue?.created).format("HH:mm")
                                            }
                                        />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text content={tempoEspera} />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text content={horarioAtendimento} />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text content={tempoAtendimento} />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text content={horarioEncerramento} />
                                    </FlexItem>
                                </Flex>

                            </React.Fragment>
                        );
                    })}
                </Grid>
            }

            {(props.loadingInfinite && props.item.length >= props.pageSize) && <LoaderInfinite />}
        </Flex>
    );
};

const listagemEncerradoWithTranslation = withTranslation()(ListagemEncerrado);
export default listagemEncerradoWithTranslation;